import "./RemodelingPlanningGuide.module.css";
import Header from "@/reusable_sections/Header";
import PlanningIntro from "./sections/PlanningIntro";
import RenovationGuidance from "./sections/RenovationGuidance";
import ServicesDirectory from "./sections/ServicesDirectory";
import EstimateRequest from "./sections/EstimateRequest";
import Footer from "@/reusable_sections/Footer";
export default function RemodelingPlanningGuidePage() {
  return <div>
      <Header />
      <PlanningIntro />
      <RenovationGuidance />
      <ServicesDirectory />
      <EstimateRequest />
      <Footer />
    </div>;
}